import React from 'react';
import { Container, makeStyles, Paper } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AboutPage } from './AboutPage/AboutPage';
import { Footer } from './Components/Footer';
import { Header } from './Components/Header';
import { ContactPage } from './ContactPage/ContactPage';
import { CreditsPage } from './CreditsPage/CreditsPage';
import { HomePage } from './HomePage/HomePage';
import { PrivacyPolicyPage } from './PrivacyPolicyPage/PrivacyPolicyPage';
import { ScreenshotPage } from './ScreenshotPage/ScreenshotPage';
import { TroubleshootingPage } from './TroubleshootingPage/TroubleshootingPage';

const useStyles = makeStyles({
  page: {
    marginTop: '1em',
    marginBottom: '1em',
    padding: '1rem',
    minHeight: '50vh',
  },
});

function App(): JSX.Element {
  const classes = useStyles();
  return (
    <Router>
      <CssBaseline />
      <Container>
        <Paper className={classes.page}>
          <Header />
          <Switch>
            <Route path="/screenshots" exact={true}>
              <ScreenshotPage />
            </Route>
            <Route path="/contact" exact={true}>
              <ContactPage />
            </Route>
            <Route path="/troubleshooting" exact={true}>
              <TroubleshootingPage />
            </Route>
            <Route path="/about" exact={true}>
              <AboutPage />
            </Route>
            <Route path="/credits" exact={true}>
              <CreditsPage />
            </Route>
            <Route path="/privacy-policy" exact={true}>
              <PrivacyPolicyPage />
            </Route>
            <Route path="/" exact={true}>
              <HomePage />
            </Route>
          </Switch>
        </Paper>
        <Footer />
      </Container>
    </Router>
  );
}

export default App;
